import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const EDIT_DEVICE_NAME_SCHEMA = z.object({
  display_name: z.string(),
  device_id: z.string(),
});

export type EditDeviceNameSchema = z.infer<typeof EDIT_DEVICE_NAME_SCHEMA>;

/**@deprecated */
export const editDeviceNamePromise = async (param: EditDeviceNameSchema) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    if (!EDIT_DEVICE_NAME_SCHEMA.safeParse(param).success) {
      console.error('Invalid Params');
      throw new Error('Invalid Params');
    }

    const response = await ky.patch(`${ENV.API_URL}/api/displays/${param.device_id}/`, {
      headers,
      body: JSON.stringify({
        payload: JSON.stringify({ display_name: param.display_name }),
      }),
    });

    if (response.ok) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error in editDeviceNamePromise', error);
    throw new Error('Error in editDeviceNamePromise');
  }
};
